module.exports = __webpack_public_path__ + "img/1245928836.ba7e9719.jpg";